/**
 * Created by ok on 5/1/16.
 */
export const UserException = (message) => {
    this.message = message;
    this.type = "UserException";
};

export const ArgumentException = (message) => {
    this.message = message;
    this.type = "ArgumentException";
};



// WEBPACK FOOTER //
// ./src/Exceptions.js